import { render, staticRenderFns } from "./page-not-found.html?vue&type=template&id=21653d3a&external"
import script from "./page-not-found.vue?vue&type=script&lang=js"
export * from "./page-not-found.vue?vue&type=script&lang=js"
import style0 from "./page-not-found.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports